// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_mainContainer__3zgmT {
    display: flex;
    flex-direction: row;
    height: 100%;
}

.login_provider__Ll1Yu {
    flex-basis: 66.66%;
    background-color: red;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    vertical-align: center;
}

.login_provider__Ll1Yu img {
    width: 50%;
    height: auto;
}

.login_login__dcpAY {
    flex-basis: 33.33%;
    background-color: #FAFAFA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.login_title__qnW6a {
    color: #333;
    opacity: 80%;
    font-size: 1.7rem;
}

.login_loginBox__ELjPA {
    margin: 0 auto; /* Added property */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #FFF;
    border-radius: 8px;
    width: 80%;
    gap: 16px;
    text-align: left;
    padding: 16px;
}

.login_loginTitle__vFJMH {
    color: #333;
    opacity: 80%;
    font-size: xx-large;
}

.login_loginTitle__vFJMH+div {
    color: #71767D;
    opacity: 80%;
    font-size: large;
    line-height: 20px;
}

@media (max-width: 1400px) {
    .login_provider__Ll1Yu {
        flex-basis: 50%;
    }

    .login_login__dcpAY {
        flex-basis: 50%;
    }
}

@media (max-width: 1050px) {
    .login_provider__Ll1Yu {
        flex-basis: 0;
    }

    .login_login__dcpAY {
        flex-basis: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/providers/login/login.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc,EAAE,mBAAmB;IACnC,uCAAuC;IACvC,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".mainContainer {\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n}\n\n.provider {\n    flex-basis: 66.66%;\n    background-color: red;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    vertical-align: center;\n}\n\n.provider img {\n    width: 50%;\n    height: auto;\n}\n\n.login {\n    flex-basis: 33.33%;\n    background-color: #FAFAFA;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-content: center;\n}\n\n.title {\n    color: #333;\n    opacity: 80%;\n    font-size: 1.7rem;\n}\n\n.loginBox {\n    margin: 0 auto; /* Added property */\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    background-color: #FFF;\n    border-radius: 8px;\n    width: 80%;\n    gap: 16px;\n    text-align: left;\n    padding: 16px;\n}\n\n.loginTitle {\n    color: #333;\n    opacity: 80%;\n    font-size: xx-large;\n}\n\n.loginTitle+div {\n    color: #71767D;\n    opacity: 80%;\n    font-size: large;\n    line-height: 20px;\n}\n\n@media (max-width: 1400px) {\n    .provider {\n        flex-basis: 50%;\n    }\n\n    .login {\n        flex-basis: 50%;\n    }\n}\n\n@media (max-width: 1050px) {\n    .provider {\n        flex-basis: 0;\n    }\n\n    .login {\n        flex-basis: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `login_mainContainer__3zgmT`,
	"provider": `login_provider__Ll1Yu`,
	"login": `login_login__dcpAY`,
	"title": `login_title__qnW6a`,
	"loginBox": `login_loginBox__ELjPA`,
	"loginTitle": `login_loginTitle__vFJMH`
};
export default ___CSS_LOADER_EXPORT___;
